import React, { useState } from 'react';
import {
  Alert,
  Button,
  Container,
  Radio,
  Grid,
  FormControl,
  RadioGroup,
  FormControlLabel,
  TextField,
} from '@mui/material';
import classes from './ForgotPassword.module.scss';
import { DataPostApiV2 } from '../../helpers/PostDataApi';
import { config } from '../../constants';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const resetMethods = {
  userName: 'userName',
  email: 'email',
  undecided: 'undecided',
};

const ForgotPassword = ({ t }) => {
  const [resetMethod, setResetMethod] = useState(resetMethods.undecided);
  const [radioValue, setRadioValue] = useState(resetMethods.undecided);
  const [userName, setUserName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState({
    error: false,
    message: '',
    haveMessage: false,
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (resetMethod === resetMethods.userName) {
      if (userName?.length > 0) {
        DataPostApiV2(config.BASEURL + `v2/users/forgotPassword`, { userName: userName.trim() }, null, false)
          .then((_response) => {
            setMessage({
              error: false,
              message: 'A link to reset your password was sent to your email!',
              haveMessage: true,
            });
          })
          .catch((err) => {
            setMessage({
              error: true,
              message: err.response?.data?.message,
              haveMessage: true,
            });
          });
      } else {
        // invalid
        setMessage({
          error: true,
          message: 'Username is not valid!',
          haveMessage: true,
        });
      }
    }
    if (resetMethod === resetMethods.email) {
      if (email?.length > 0) {
        DataPostApiV2(config.BASEURL + `v2/users/forgotPassword`, { email: email.trim() }, null, false)
          .then((_response) => {
            setMessage({
              error: false,
              message: 'Reset password link sent to your email!',
              haveMessage: true,
            });
          })
          .catch((err) => {
            setMessage({
              error: true,
              message: err.response?.data?.message,
              haveMessage: true,
            });
            if (err.data.isMultipleUsers) {
              setResetMethod('undecided');
            }
          });
      } else {
        // invalid
        setMessage({
          error: true,
          message: 'Email is not valid!',
          haveMessage: true,
        });
      }
    }
  };

  const handleBackToSelection = () => {
    setMessage({
      error: false,
      message: '',
      haveMessage: false,
    });
    setResetMethod(resetMethods.undecided);
  };

  const handleBackToLogin = () => {
    setMessage({
      error: false,
      message: '',
      haveMessage: false,
    });
    window.location.href = '/Login';
  };

  const handleRadioChange = (event) => {
    setRadioValue(event.target.value);
  };

  const getSubmitLink = () => {
    switch (radioValue) {
      case resetMethods.userName:
        setResetMethod(radioValue);
        break;
      case resetMethods.email:
        setResetMethod(radioValue);
        break;
      default:
    }
  };

  return (
    <div className={classes.forgotPassword}>
      {resetMethod === resetMethods.undecided && (
        <Container component="main" className={classes.max_Width}>
          <div className={classes.paperWhite}>
            <Grid container rowSpacing={2}>
              <Grid item xs={12} md={12}>
                <span data-cy="forgot-password-text">Do you remember your username?</span>
              </Grid>
              <Grid item xs={12} md={12}>
                <FormControl component="fieldset">
                  <RadioGroup
                    data-cy="username-reminder-radio"
                    aria-label="username-reminder"
                    name="username-reminder"
                    value={radioValue}
                    onChange={handleRadioChange}
                  >
                    <FormControlLabel value={resetMethods.userName} control={<Radio color="primary" />} label="Yes" />
                    <FormControlLabel value={resetMethods.email} control={<Radio color="primary" />} label="No" />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={12}>
                <Grid container justifyContent={'flex-end'} alignItems={'center'} columnSpacing={2}>
                  <Grid item className={classes.text_right}>
                    <Button id="backToSelection" variant="text" color="primary" onClick={handleBackToLogin}>
                      Back
                    </Button>
                  </Grid>
                  <Grid item className={classes.text_right}>
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={radioValue === resetMethods.undecided} // Disable the button if no option is selected
                      onClick={getSubmitLink}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </Container>
      )}
      {resetMethod === resetMethods.userName && (
        <Container component="main" className={classes.max_Width}>
          <div className={classes.paperWhite}>
            <Grid container rowSpacing={2}>
              {message.haveMessage && (
                <Grid item xs={12} md={12}>
                  <Alert severity={message.error ? 'error' : 'success'}>{message.message}</Alert>
                </Grid>
              )}

              <Grid item xs={12} md={12}>
                <TextField
                  required={true}
                  id="username"
                  type="username"
                  label={'Username'}
                  value={userName}
                  fullWidth
                  onChange={(e) => setUserName(e.target.value)}
                  autoFocus
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleSubmit(e);
                    }
                  }}
                />
              </Grid>
              <Grid item container justifyContent={'flex-end'} alignItems={'center'} columnSpacing={2}>
                <Grid item>
                  <Button id="backToSelection" variant="text" color="primary" onClick={handleBackToSelection}>
                    Back
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    id="checkUserName"
                    fullWidth
                    variant="contained"
                    color="primary"
                    onClick={(e) => handleSubmit(e)}
                  >
                    {t('ResetPassword')}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </Container>
      )}
      {resetMethod === resetMethods.email && (
        <Container component="main" className={classes.max_Width}>
          <div className={classes.paperWhite}>
            <Grid container rowSpacing={2}>
              {message.haveMessage && (
                <Grid item xs={12} md={12}>
                  <Alert severity={message.error ? 'error' : 'success'}>{message.message}</Alert>
                </Grid>
              )}
              <Grid item xs={12} md={12}>
                <TextField
                  required={true}
                  id="email"
                  type="email"
                  label={'Email'}
                  value={email}
                  fullWidth
                  onChange={(e) => setEmail(e.target.value)}
                  autoFocus
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleSubmit(e);
                    }
                  }}
                />
              </Grid>
              <Grid item container justifyContent={'flex-end'} alignItems={'center'} columnSpacing={2}>
                <Grid item>
                  <Button id="backToSelection" variant="text" color="primary" onClick={handleBackToSelection}>
                    Back
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    id="checkEmail"
                    fullWidth
                    variant="contained"
                    color="primary"
                    onClick={(e) => handleSubmit(e)}
                  >
                    {t('ResetPassword')}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </Container>
      )}
    </div>
  );
};

ForgotPassword.propTypes = {
  t: PropTypes.func,
};

export default withTranslation()(ForgotPassword);
